module.exports = __webpack_public_path__ + "img/پیچیده.7b6a6aab.png";